export const oneNoteAppName = "YJiec";
export default {oneNoteAppName};